/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { ChevronLeftIcon, colors } from "@dotnet/telematics-design-system";

import ListChoice from "../../../components/ListChoice/ListChoice";

interface IGoBackButtonClick {
  onButtonClick: any;
}

const GoBackButton = ({ onButtonClick }: IGoBackButtonClick) => {
  const { t } = useTranslation();

  return (
    <ListChoice
      title={t("Button##go back")}
      iconLeft={<ChevronLeftIcon />}
      onClick={onButtonClick}
      css={css({ background: colors.white, color: colors.blue700 })}
    />
  );
};

export default GoBackButton;
